// AUTO-GENERATED by `pnpm --filter @borradh-workspace/contracts contracts:generate`.
// DO NOT EDIT — regenerate instead. Source: Drizzle table "voice_outbound_request".
// This file is pure Zod (no drizzle-zod / database in its runtime graph).
import { z } from 'zod';
/** Response atom for the "voice_outbound_request" table (1:1 with a DB row, on the wire). */
export const voiceOutboundRequestAtomSchema = z.object({
    id: z.string(),
    organizationId: z.string(),
    leadId: z.string(),
    phoneNumberId: z.string(),
    fromNumber: z.string(),
    toNumber: z.string(),
    callMode: z.string().nullable(),
    callSid: z.string().nullable(),
    createdAt: z.string().datetime(),
});
//# sourceMappingURL=voiceOutboundRequest.js.map